import {styled} from "@mui/material/styles"
import {Typography} from "@mui/material"
import {breakpoints} from "@next/themes"

export const CategoryQuickLinksRoot = styled("div")`
    width: 100%;
    & > :not(:first-of-type) {
        margin-top: 0.875rem;
    }

    /*
        Lets ensure that the slides are not centered when there
        are not enough slides to horizontally fill the area
    */
    & .swiper-container {
        margin-left: 0;
        margin-right: 0;
    }

    & .swiper-wrapper {
        height: auto;
    }

    & .swiper-slide {
        width: 7.5rem;
        @media (min-width: ${breakpoints.values.md}px) {
            width: 11.25rem;
        }

        /*
            Disable the padding on the right for when there are
            not enough slides to horizontally fill the area. If
            it's not disabled, then the chevron will appear at
            side of the image and not on top of the image
        */
        &:last-child {
            margin-right: 0 !important;
        }
    }

    & .swiper-button-prev,
    .swiper-button-next {
        color: #000;
        width: 1.75rem;
        height: 2.25rem;
        background: rgba(255, 255, 255, 1);
        display: none;
        top: 38%;
        &.swiper-button-disabled {
            display: none;
        }
        &:after {
            font-size: 0.875rem;
            font-weight: bold;
        }
        @media (min-width: ${breakpoints.values.lg}px) {
            display: flex;
        }
    }
    & .swiper-button-prev {
        left: 0;
        border-left: 0;
        border-radius: 0 0.5rem 0.5rem 0;
        &:after {
            margin-left: -0.125rem;
        }
    }
    & .swiper-button-next {
        right: 0;
        border-right: 0;
        border-radius: 0.5rem 0 0 0.5rem;
        &:after {
            margin-right: -0.125rem;
        }
    }
`

export const CategoryQuickLinksTitle = styled(Typography)`
    font-size: 1rem;
    font-family: ${({theme}) => `${theme.colours.font.primary.medium.family}, ${theme.colours.font.default}`};
    font-weight: ${({theme}) => theme.colours.font.primary.medium.weight};
    line-height: 1.5rem;
    letter-spacing: 0.0075rem;
`.withComponent("h1")

export const CategoryQuickLinkItems = styled("div")`
    position: relative;
`

export const EmblaViewport = styled("div")({
    listStyle: "none",
    marginLeft: "auto",
    marginRight: "auto",
    padding: 0,
    position: "relative",
    zIndex: 1,
    overflow: "hidden",
})

export const EmblaContainer = styled("div")(() => ({
    boxSizing: "initial",
    display: "flex",
    width: "100%",
    zIndex: 1,
    backfaceVisibility: "hidden",
    transitionDuration: "0ms",
}))

export const EmblaSlide = styled("div")<{$slidesPerView?: number; $spaceBetween?: number}>(
    ({$slidesPerView = 1, $spaceBetween = 0}) => `
    position: relative;
    min-width: 0;
    flex: 0 0 calc(100% / ${$slidesPerView});
    margin-inline-end: ${$spaceBetween}px;
`,
)

export const StyledImageNavigationContainer = styled("div")<{
    $side: "left" | "right"
    $show: boolean
    $rotate?: number
}>(({$side, $show, $rotate = 0}) => ({
    zIndex: 1,
    width: "auto",
    aspectRatio: 1,
    position: "absolute",
    top: "30%",
    left: $side === "left" ? -14 : "auto",
    right: $side === "right" ? -14 : "auto",
    transform: `translate(0, -50%) rotate(${$rotate}deg)`,
    display: $show ? "flex" : "none",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    opacity: $show ? 1 : 0,
    transition: "opacity 0.2s ease-in-out",
}))

export const StyledIconButton = styled("button")`
    width: 2rem;
    height: 2rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
`
export const Icon = styled("svg")`
    stroke-dasharray: 40;
    stroke-dashoffset: 80;
    stroke-linecap: round;
    width: 0.41375rem;
    height: 0.75rem;
    stroke: #000;
    fill: #000;
`
